import { render } from "./CollectionCardYellowIncubator.vue?vue&type=template&id=76c7d8a2"
import script from "./CollectionCardYellowIncubator.vue?vue&type=script&lang=js"
export * from "./CollectionCardYellowIncubator.vue?vue&type=script&lang=js"

import "./CollectionCardYellowIncubator.vue?vue&type=style&index=0&id=76c7d8a2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__